module.exports = __webpack_public_path__ + "img/fi.dd5c04dc.png";